// 2026-10-30 — API errors now carry detail={code,message} (e.g. QUARTERLY_MIRROR)
// and ~100 handlers pass `e.response.data.detail` straight to toast.*, which
// crashes React ("Objects are not valid as a React child"). Coerce once here.
import { isValidElement } from 'react';
import { toast } from 'sonner';

export function toastText(msg) {
  if (msg == null || typeof msg === 'string' || typeof msg === 'number' || isValidElement(msg)) return msg;
  if (Array.isArray(msg)) return msg.map((m) => m?.msg || m?.message || String(m)).join(' · ');
  if (typeof msg === 'object') return msg.message || msg.detail || msg.msg || 'Something went wrong';
  return String(msg);
}

['error', 'success', 'info', 'warning', 'message'].forEach((k) => {
  const orig = toast[k];
  if (typeof orig === 'function') toast[k] = (msg, opts) => orig(toastText(msg), opts);
});
